/** PURE_IMPORTS_START .._operators_combineLatest PURE_IMPORTS_END */
import { CombineLatestOperator } from '../operators/combineLatest';
export function combineAll(project) {
    return function (source) { return source.lift(new CombineLatestOperator(project)); };
}
//# sourceMappingURL=combineAll.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operators/combineAll.js
// module id = 235
// module chunks = 0